<div class="ki-gesendet">
  <button
    type="button"
    class="ki-gesendet__toggle"
    data-testid="ki-gesendet-toggle"
    [attr.aria-expanded]="offen()"
    (click)="umschalten()"
  >
    <mat-icon class="ki-gesendet__chevron" [class.ki-gesendet__chevron--offen]="offen()" aria-hidden="true">
      chevron_right
    </mat-icon>
    {{ 'ki.gesendet.toggle' | translate }}
  </button>
  @if (offen()) {
    <div class="ki-gesendet__inhalt">
      <div>
        <strong>{{ 'ki.gesendet.an' | translate }}</strong>
        {{ gesendet().anbieter }} · {{ 'ki.gesendet.modell' | translate }}
        <code class="ki-gesendet__modell">{{ gesendet().modell }}</code>
        · {{ 'ki.gesendet.region' | translate }} {{ gesendet().region }}
      </div>
      <div>
        <strong>{{ 'ki.gesendet.inhalte' | translate }}</strong>
        {{ inhalte() }}
      </div>
      <div class="ki-gesendet__maskiert">
        {{ 'ki.gesendet.maskiert' | translate }}
        @if (gesendet().eigeneMuster > 0) {
          {{ 'ki.gesendet.eigeneMuster' | translate: { anzahl: gesendet().eigeneMuster } }}
        }
      </div>
    </div>
  }
</div>
